const CommunityDeleteButtonBox = ({ title = "삭제", onClick }) => {
    return (
        <button type="button" className="btn red" onClick={(e) => onClick(e)}>
            {title}
        </button>
    );
};

export default CommunityDeleteButtonBox;